import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { VALUE_DIFFERENCE_DISPLAY } from 'components/View/constants';

import { CMASummaryFilters } from './types';
import { formatAmount, formatPercentage } from './utils';

const Difference = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  margin-left: 2px;
`;

const DEFAULT_DOLLAR_PREFIX = '$';

type Props = {
  difference?: number | null;
  prefix?: string;
  dataTestId?: string;
};

const CMASummaryTableDataValuesDifference = ({ difference, prefix = DEFAULT_DOLLAR_PREFIX, dataTestId }: Props) => {
  const { viewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;

  if (!difference) {
    return null;
  }

  return (
    <Difference color={difference < 0 ? 'var(--negative-orange)' : 'var(--positive-green)'} data-test-id={dataTestId}>
      {filters?.viewOptions?.valueDisplay === VALUE_DIFFERENCE_DISPLAY.AMOUNTS &&
        formatAmount(prefix, difference)}
      {filters?.viewOptions?.valueDisplay === VALUE_DIFFERENCE_DISPLAY.PERCENTAGES &&
        formatPercentage(difference)}
    </Difference>
  );
};

export default CMASummaryTableDataValuesDifference;
